export class ParametriRicercaRendicontazione {
  societaId: number;
  livelloTerritorialeId: number;
  enteId: number;
  servizioId: number;
  transazioneId: string;
  codiceIUV: string;
  tipologiaServizioId: number;
  canaleId: number;
  dataPagamentoDa: string;
  dataPagamentoA: string;
  importoTransazioneDa: number;
  importoTransazioneA: number;
  flussoRendicontazioneId: number;
  dataCreazioneRendicontoDa: string;
  dataCreazioneRendicontoA: string;
  tipoFlussoId: number;
  numeroPagina: string;
  numeroElementi: string;
  sort: string;
  ascending: string;
  pagination: boolean;
  raggruppamentoId: number = null;
}
